import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { FC } from 'react';
import { DialogContent, Skeleton, TextField } from '@mui/material';
import { Notice } from 'ui/Notice';
import { useDispatch, useSelector } from 'react-redux';
import { attachSkusRequest, attachSkusReset } from 'redux/reducers/gpsr/reducer';
import { getGpsrAttachSkuIsLoad, getGpsrAttachSkuMessage } from 'redux/reducers/gpsr/selectors';
import { TAddNewSkusDialogProps } from './types';

export const AddNewSkusDialog: FC<TAddNewSkusDialogProps> = ({ open, setClose, productTypeId }) => {
	const dispatch = useDispatch();
	const [newSKUs, setNewSKUs] = React.useState<string>('');

	const responseMessage = useSelector(getGpsrAttachSkuMessage);
	const responseMessageLoading = useSelector(getGpsrAttachSkuIsLoad);
	// console.log('responseMessage', responseMessage);

	const handleAdd = (skusTxt: string) => {
		if (!productTypeId) return;
		dispatch(
			attachSkusRequest({
				productTypeId,
				body: {
					skusTxt,
				},
			}),
		);
	};

	const handleClose = () => {
		dispatch(attachSkusReset());
		setClose();
		setNewSKUs('');
		window.location.reload();
	};

	return (
		<Dialog
			open={open}
			onClose={setClose}
			sx={{
				'& .MuiDialog-paper': {
					width: '500px',
					maxWidth: '500px',
					borderRadius: '12px',
					height: '400px',
				},
			}}
		>
			<DialogTitle color="primary">Add New SKUs</DialogTitle>
			{responseMessageLoading && (
				<DialogContent>
					<Skeleton variant="text" />
					<Skeleton variant="text" />
					<Skeleton variant="text" />
				</DialogContent>
			)}
			{!responseMessageLoading && responseMessage && (
				<DialogContent>
					<Notice
						sx={{
							margin: '0px!important',
						}}
						text={responseMessage.message}
					/>
				</DialogContent>
			)}
			{!responseMessageLoading && !responseMessage && (
				<DialogContent
					sx={{
						p: '0 12px 0px 12px',
					}}
				>
					<Notice
						sx={{
							margin: '0px!important',
						}}
						text="Add the new SKUs you want to add to the system. Each SKU should be on a new line."
					/>
					<TextField
						sx={{
							mt: '12px',
							'& .MuiInputBase-root': {
								padding: '6px 8px',
								lineHeight: '1.5',
								borderRadius: '12px',
								// fontSize: '0.9rem',
							},
						}}
						autoFocus
						label="Add New SKUs"
						value={newSKUs}
						onChange={(e) => setNewSKUs(e.target.value)}
						type="text"
						fullWidth
						multiline
						rows={6}
					/>
				</DialogContent>
			)}
			<DialogActions>
				{!responseMessageLoading && !responseMessage && (
					<>
						<Button
							onClick={handleClose}
							sx={{
								textTransform: 'none',
							}}
						>
							Cancel
						</Button>
						<Button
							onClick={() => handleAdd(newSKUs)}
							autoFocus
							sx={{
								textTransform: 'none',
							}}
						>
							Send
						</Button>
					</>
				)}
				{!responseMessageLoading && responseMessage && (
					<Button
						onClick={handleClose}
						sx={{
							textTransform: 'none',
						}}
					>
						Close
					</Button>
				)}
			</DialogActions>
		</Dialog>
	);
};
